import React from 'react';
import {CuentaNotaEstructurada, CuentaNotaEstructuradaDetalle} from "../types/types";
import {useConfirmationDialog} from "../../../../../hooks/useConfirmationDialog";
import {Box, Card, CardContent, Grid, IconButton, Tooltip, Typography} from "@mui/material";
import {HttpContraparte} from "../../contraparte/api/httpContraparte";
import {EntityWithIdFields} from "../../../../../types";
import toast from "react-hot-toast";
import DeleteIcon from "@mui/icons-material/Delete";
import {ITableColumn, TableList} from "../../../../../components/table";
import {HttpNotaEstructurada} from "../api/httpNotaEstructurada";
import {CuentaContraparteDetalle} from "../../contraparte/types/types";
import {OperacionNotaEstructuradaCuentaFields, OperacionNotaEstructuradaDetalleFields} from '../types/fields';
import NotaEstructuradaCampoLimite from "./NotaEstructuradaCampoLimite";
import {OperacionNotaEstructuradaCuentaDetalleUpdate, OperacionNotaEstructuradaDetalleUpdate} from "../types/dto";

interface NotaEstructuradaCuentaProps {
  idOperacion: number
  codPais: number
  cuenta: CuentaNotaEstructurada
  refetch: () => void
  permiteEliminar: boolean
  permiteEditar: boolean
}

function NotaEstructuradaCuenta({idOperacion, codPais, cuenta, refetch, permiteEliminar, permiteEditar}: NotaEstructuradaCuentaProps) {
  const {askConfirmation} = useConfirmationDialog();

  const alGuardarCuentaDetalle = (data: OperacionNotaEstructuradaCuentaDetalleUpdate, idCuentaDetalle:number) => {
    const dataToSave = {
      ...data,
    }
    const promise = HttpNotaEstructurada.putCuentaDetalle(idOperacion, cuenta.id, idCuentaDetalle, data)

    toast.promise(promise, {
      loading: 'Guardando.',
      success: 'Guardado correctamente.',
      error: e => `${e}`
    }).finally(() => {
     // reset()
      refetch()
    })
  }


  const columns: ITableColumn[] = [
      {
        label: 'Sector comercial',
        width: '40%',
        value: OperacionNotaEstructuradaCuentaFields.Sector,
        onRenderCell: (entity: CuentaNotaEstructuradaDetalle) => {
          let estilo = {}
          try {
            estilo = JSON.parse(entity[OperacionNotaEstructuradaCuentaFields.Estilo] || '{}');
          } catch (error) {
            console.error("No se pudo parsear el JSON de estilo:", entity[OperacionNotaEstructuradaCuentaFields.Estilo]);
          }

          return (
            <Typography noWrap variant='body2'
                        sx={{
                          ...estilo,
                        }}
            >
              {entity[OperacionNotaEstructuradaCuentaFields.Sector]}
            </Typography>
          )
        }
      },
      {
        label: 'Concertación',
        value: OperacionNotaEstructuradaCuentaFields.ImporteConcertacion,
        width: '20%',
        onRenderCell: (cuentaDetalle: CuentaNotaEstructuradaDetalle) => {
          return (
            <NotaEstructuradaCampoLimite
              detalle={cuentaDetalle}
              codPais={codPais}
              permiteEditar={cuentaDetalle[OperacionNotaEstructuradaCuentaFields.PermiteModificar]}
              tipoLimite={'concertacion'}
              handleConfirm={alGuardarCuentaDetalle}
            />
          )
        }
      },
      {
        label: 'DVP',
        value: OperacionNotaEstructuradaCuentaFields.ImporteDPV,
        width: '20%',
        onRenderCell: (cuentaDetalle: CuentaNotaEstructuradaDetalle) => {
          return (
            <NotaEstructuradaCampoLimite
              detalle={cuentaDetalle}
              codPais={codPais}
              permiteEditar={cuentaDetalle[OperacionNotaEstructuradaCuentaFields.PermiteModificar]}
              tipoLimite={'DVP'}
              handleConfirm={alGuardarCuentaDetalle}
            />
          )
        }
      },
      {
        label: 'FOP',
        value: OperacionNotaEstructuradaCuentaFields.ImporteFOP,
        width: '20%',
        onRenderCell: (cuentaDetalle: CuentaNotaEstructuradaDetalle) => {
          return (
            <NotaEstructuradaCampoLimite
              detalle={cuentaDetalle}
              codPais={codPais}
              permiteEditar={cuentaDetalle[OperacionNotaEstructuradaCuentaFields.PermiteModificar]}
              tipoLimite={'FOP'}
              handleConfirm={alGuardarCuentaDetalle}
            />
          )
        }
      }
    ]
  
  return (
    <Card>
      <Box display='flex' justifyContent='flex-end'>
        {
          permiteEliminar &&
            <Tooltip title='Eliminar'>
                <IconButton
                    onClick={
                      () => askConfirmation(
                        () => {
                          const promise = HttpNotaEstructurada.deleteCuenta(idOperacion, cuenta[EntityWithIdFields.Id])

                          toast.promise(promise, {
                            success: 'Eliminado',
                            error: 'No se pudo eliminar',
                            loading: 'Eliminando'
                          }).then(() => refetch())
                        }
                      )
                    }
                >
                    <DeleteIcon color='error'/>
                </IconButton>
            </Tooltip>
        }
      </Box>
      <CardContent>
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Typography variant='body2'>Número de cuenta</Typography>
              <Typography variant='body1'>{cuenta[OperacionNotaEstructuradaCuentaFields.NroCuenta]}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant='body2'>Razón social</Typography>
              <Typography variant='body1'>{cuenta[OperacionNotaEstructuradaCuentaFields.RazonSocial]}</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography variant='body2'>Moneda</Typography>
              <Typography variant='body1'>{cuenta[OperacionNotaEstructuradaCuentaFields.DescMoneda]}</Typography>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
      <Box>
        <TableList
          entityList={cuenta[OperacionNotaEstructuradaCuentaFields.Detalles]}
          columns={columns}
          isLoading={false}
          error={false}
        />
      </Box>
    </Card>
  );
}

export default NotaEstructuradaCuenta;